import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Services from "../views/Services.vue";
import SingleService from "../views/SingleService";
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";
import ContactFormSuccess from "@/components/partials/ContactFormSuccess";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
  },
  {
    path: '/services/:slug',
    name: 'SingleService',
    component: SingleService,
    props: true
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  {
    path: '/thanks',
    name: 'success',
    component: ContactFormSuccess
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
